import React from "react";
import {
  Container,
  Grid,
  Header,
  Icon,
  List,
  Segment,
} from "semantic-ui-react";

const Footer = () => {
  return (
    <Segment inverted vertical style={{ padding: "5em 0em" }}>
      <Container>
        <Grid divided inverted stackable>
          <Grid.Row>
            <Grid.Column width={4}>
              <Header inverted as="h4" content="Services" />
              <List link inverted>
                <List.Item as="a" href="https://altosresearch.com">
                  Altos Research
                </List.Item>
                <List.Item as="a" href="https://altosresearch.com/contact">
                  Contact Us
                </List.Item>
                <List.Item as="a" href="https://blog.altosresearch.com">
                  Blog
                </List.Item>
              </List>
            </Grid.Column>

            <Grid.Column width={4}>
              <Header inverted as="h4" content="About" />
              <List link inverted>
                <List.Item as="a" href="/docs">
                  Documentation
                </List.Item>
                <List.Item as="a" href="mailto:sales@altosresearch.com">
                  Sales
                </List.Item>
                <List.Item as="a" href="mailto:support@altosresearch.com">
                  Support
                </List.Item>
              </List>
            </Grid.Column>

            <Grid.Column width={4}>
              <Header as="h4" inverted>
                Follow us
              </Header>
              <List.Item as="a" href="https://twitter.com/altosresearch">
                <Icon name="twitter" size="big" style={{ color: "#fff" }} />
              </List.Item>
              <List.Item as="a" href="https://www.youtube.com/altosresearch">
                <Icon name="youtube" size="big" style={{ color: "#fff" }} />
              </List.Item>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};

export default Footer;
